import { AISwitcherOptionsProps } from '../service/ai.interface';

export const optionsSwitch: AISwitcherOptionsProps[] = [
    {
        name: 'ИИ-чат в магазине',
        type: 'ai-telegram',
    },
];
